import cssSVG from "../assets/css.svg";
import jsSVG from "../assets/js.svg";
import reactSVG from "../assets/react.svg";
import sassSVG from "../assets/sass.svg";
import expressSVG from "../assets/express.svg";
import tailwindSVG from "../assets/tailwind.svg";
import reduxSVG from "../assets/redux.svg";
import mongodbSVG from "../assets/mongodb.svg"
import mySqlSVG from "../assets/mysql.svg"
import { motion } from "framer-motion";

const About = () => {
  // Variants
  const containerVars = {
    initial: { opacity: 0 },
    animate: {
      opacity: 1,
      transition: {
        staggerChildren: 0.6,
      },
    },
  };

  const itemVars = {
    initial: { opacity: 0, x: -100 },
    animate: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  return (
    <section id="about" className="about container">
      <div className="section__heading">
        <h3 className="section__heading--sub">- About me</h3>
        <h2 className="section__heading--main">Full Stack Web Developer</h2>
      </div>
      <div className="about__me">
        <p className="about__me--text">
          Hello there! My name is <span>Rehan Shafqat</span>. I am a <span>
            Full Stack (MERN and Springboot) Developer &nbsp;
          </span>
          and I'm very passionate and dedicated towards the <span>
            Software development</span>.
        </p>
        <p className="about__me--text">
          From my earliest interactions with the web, I've been intrigued by its
          potential to seamlessly connect people and ideas. This fascination led
          me to embark on a self-taught journey into frontend development. While
          my journey may be relatively fresh, through my strong{" "}
          <span>problem-solving skills</span>, <span>logical thinking</span>,
          and countless hours of learning, experimenting, and building, I've
          gained proficiency in React.js development.
        </p>
      </div>

      <div className="tech-stack">
        <p className="tech-stack__text">tech stack</p>
        <motion.div
          variants={containerVars}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
          className="tech-stack__images"
        >
          <motion.span variants={itemVars} className="tech-stack__img">
            <img src={cssSVG} alt="html" />
          </motion.span>

          <motion.span variants={itemVars} className="tech-stack__img">
            <img src={sassSVG} alt="html" />
          </motion.span>

          <motion.span variants={itemVars} className="tech-stack__img">
            <img src={tailwindSVG} alt="html" />
          </motion.span>

          <motion.span variants={itemVars} className="tech-stack__img">
            <img src={jsSVG} alt="html" />
          </motion.span>

          <motion.span variants={itemVars} className="tech-stack__img">
            <img src={reactSVG} alt="html" />
          </motion.span>





          <motion.span variants={itemVars} className="tech-stack__img">
            <img src={reduxSVG} alt="html" />
          </motion.span>
          <motion.span variants={itemVars} className="tech-stack__img">
            <img src={mongodbSVG} alt="html" />
          </motion.span>
          <motion.span variants={itemVars} className="tech-stack__img">
            <img src={mySqlSVG} alt="html" />
          </motion.span>
          <motion.span variants={itemVars} className="tech-stack__img">
            <img src={expressSVG} alt="html" />
          </motion.span>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
